// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkDownloadPing-cls1_XOM","cls2":"BulkDownloadPing-cls2_AZH BulkDownloadPing-cls1_XOM"};